import React from 'react'

import DairyDropdown from "../DairyDropdown/DairyDropdown"
import ReportDropdown from "../ReportDropdown/ReportDropdown"
import SampleStore from "../SampleStore/SampleStore"
import ViewTypeDropdown from "../ViewTypeDropdown/ViewTypeDropdown";
import ViewDateRangeSelector from "../ViewDateRangeSelector/ViewDateRangeSelector";
import "./mainpage.css"
import MainSection from "../MainSection/MainSection";

import PropTypes from 'prop-types'
import {GetReportForNewDairy, GetMostRecentReport} from "./MainPageHelpers";
import {DEFAULT_PROPS, INITIAL_VALUES} from "./MainPageConstants";
import {SAMPLE_TYPES_CODES, VIEW_TYPES} from "../../utils/constants"
import {GenerateDate, GenerateFirstOfTheMonth, ToFullSampleTypeName} from "../../utils/helpers";

export default class MainPage extends React.Component{
	static defaultProps = {
		dairyInfo: {
			dairy_id: DEFAULT_PROPS.DAIRY_ID,
			dairy_name: DEFAULT_PROPS.DAIRY_NAME,
			dairy_login_username: DEFAULT_PROPS.USERNAME,
			dairy_login_last_login: DEFAULT_PROPS.LAST_LOGIN,
			subdairies: DEFAULT_PROPS.SUBDAIRIES,
			reports: DEFAULT_PROPS.REPORTS
		}
	}
	
	static propTypes = {
		dairyInfo: PropTypes.shape({
			dairy_id: PropTypes.number,
			dairy_name: PropTypes.string,
			dairy_login_username: PropTypes.string,
			dairy_login_last_login: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
			subdairies: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.object]),
			reports: PropTypes.arrayOf(PropTypes.shape({
				report_id: PropTypes.number,
				report_dairy_id: PropTypes.number,
				report_type: PropTypes.string,
				report_last_updated: PropTypes.string
			}))
		})
	}
	
	constructor(props){
		super(props)
		
		let currentReportInfo = GetMostRecentReport(props.dairyInfo.dairy_id, props.dairyInfo.reports)
		
		this.state = {
			currentDairyId: this.props.dairyInfo.dairy_id,
			currentDairyName: this.props.dairyInfo.dairy_name,
			currentReportInfo: currentReportInfo,
			viewType: props.dairyInfo.dairy_login_last_login ? VIEW_TYPES.MOST_RECENT : VIEW_TYPES.MONTHLY,
			samplesFromDate: props.dairyInfo.dairy_login_last_login ?? GenerateFirstOfTheMonth(),
			samplesToDate: GenerateDate()
		}
	}
	
	changeCurrentDairyId(newDairyId){
		let { dairy_id, dairy_name, subdairies } = this.props.dairyInfo
		
		let newCurrentDairyInfo = {}
		
		if(newDairyId === this.state.currentDairyId){
			return
		}else if(dairy_id === newDairyId){
			newCurrentDairyInfo = {
				dairy_id: dairy_id,
				dairy_name: dairy_name
			}
		}else{
			newCurrentDairyInfo = subdairies.find(dairy => dairy.dairy_id === newDairyId)
		}
		
		const currentReportType = this.state.currentReportInfo ? this.state.currentReportInfo.report_type : SAMPLE_TYPES_CODES.solo
		
		const newReportInfo = GetReportForNewDairy(newDairyId, this.props.dairyInfo.reports, this.state.viewType, currentReportType)
		
		this.setState({
			currentDairyId: newCurrentDairyInfo.dairy_id,
			currentDairyName: newCurrentDairyInfo.dairy_name,
			currentReportInfo: newReportInfo
		})
	}
	
	changeCurrentReport(newReportType){
		const report = this.props.dairyInfo.reports.find(report => report.report_type === newReportType && this.state.currentDairyId === report.report_dairy_id)
		
		this.setState({
			currentReportInfo: report
		})
	}
	
	changeCurrentViewType(newViewType){
		this.setState({
			viewType: newViewType
		}, () => {
			if(newViewType === VIEW_TYPES.MOST_RECENT){
				const fromDate = this.props.dairyInfo.dairy_login_last_login ?? GenerateFirstOfTheMonth()
				const toDate = GenerateDate()
				
				this.changeCurrentDateRange(fromDate, toDate)
			}
		})
	}
	
	changeCurrentDateRange(newFromDate, newToDate){
		this.setState({
			samplesFromDate: newFromDate,
			samplesToDate: newToDate
		})
	}
	
	render(){
		let { dairy_id, dairy_name, subdairies } = this.props.dairyInfo
		
		let dairyDropdownDairiesList = [{dairy_id, dairy_name}, ...subdairies]
		
		let dairySection = (
			<MainSection title={'Dairy:'} value={this.state.currentDairyName}>
				<DairyDropdown mainDairyId={this.state.currentDairyId} dairiesList={dairyDropdownDairiesList} changeDairy={this.changeCurrentDairyId.bind(this)}/>
			</MainSection>
		)
		
		if(!this.state.currentReportInfo){
			return (
				<div>
					{dairySection}
					<MainSection title={"Report Type:"} value={`None Found`}/>
				</div>
			)
		}
		
		return (
			<main>
				{dairySection}
				<MainSection title={"Report Type:"} value={ToFullSampleTypeName(this.state.currentReportInfo.report_type)}>
					<ReportDropdown
						dairyId={this.state.currentDairyId}
						currentReportType={this.state.currentReportInfo.report_type}
						reports={this.props.dairyInfo.reports}
						changeReportType={this.changeCurrentReport.bind(this)}
					/>
				</MainSection>
				<MainSection title={"Viewing:"} value={this.state.viewType}>
					<ViewTypeDropdown
						currentViewType={this.state.viewType}
						changeViewType={this.changeCurrentViewType.bind(this)}
					/>
					<ViewDateRangeSelector
						viewType={this.state.viewType}
						changeDateRange={this.changeCurrentDateRange.bind(this)}
					/>
				</MainSection>
				<SampleStore
					reportInfo={this.state.currentReportInfo}
					dairyName={this.state.currentDairyName}
					samplesFromDate={this.state.samplesFromDate}
					samplesToDate={this.state.samplesToDate}
					onRestrictedResponse={this.props.clearCookies}
				/>
			</main>
		)
	}
}